import Page from '../../../shared/components/Page/Page';
import {Avatar, Button, Card, Col, Flex, Form, Input, message, Row, Table, Upload} from "antd";
import {AntDesignOutlined} from "@ant-design/icons";
import useAuth from "../../../shared/hooks/useAuth";
import Info from "../../../shared/components/Info/Info";
import {useContext, useEffect, useState} from "react";
import LoadingContext from "../../../app/contexts/LoadingContext";
import { updateProfile } from "../api";
import {useNavigate} from "react-router-dom";
import {redirectAuth} from "../../../app/routes";
import {getBase64} from "../../../shared/utils/helpers";
import { getLoginLogs } from "../api";
import moment from 'moment';
import { getActivityLogs } from "../api";

function Profile() {
    const { user: userData, signOut, loading } = useAuth();
    const navigate = useNavigate();
    const {setLoading} = useContext(LoadingContext);
    const [name,setName]    = useState(userData?.name || '');
    const [email,setEmail]  = useState(userData?.email || '');
    const [messageApi, contextHolder] = message.useMessage();
    const [, setImageUrl] = useState('');
    const [dataLogin, setDataLogin] = useState([]);
    const [paginationLogin, setPaginationLogin] = useState({ current: 1, pageSize: 5, total: 0 });
    const [loginLoading, setLoginLoading] = useState(false);
    const [dataActivity, setDataActivity] = useState([]);
    const [paginationActivity, setPaginationActivity] = useState({ current: 1, pageSize: 5, total: 0 });
    const [activityLoading, setActivityLoading] = useState(false);

    const loginColumns = [
        {
            title: 'ID',
            dataIndex: 'id',
            key: 'id'
        },
        {
            title: 'IP',
            dataIndex: ['properties', 'ip'],
            key: 'ip'
        },
        {
            title: 'Thiết bị',
            dataIndex: ['properties', 'userAgent'],
            key: 'user_agent',
            ellipsis: true
        },
        {
            title: 'Thời gian',
            dataIndex: 'createdAt',
            key: 'created_at',
            render: (value) => moment(value).format('DD/MM/YYYY HH:mm:ss')
        }
    ];

    const activityColumns = [
        {
            title: 'ID',
            dataIndex: 'id',
            key: 'id'
        },
        {
            title: 'IP',
            dataIndex: ['properties', 'ip'],
            key: 'ip'
        },
        {
            title: 'Thiết bị',
            dataIndex: ['properties', 'userAgent'],
            key: 'user_agent',
            ellipsis: true
        },
        {
            title: 'Ghi chú',
            dataIndex: 'description',
            key: 'description'
        },
        {
            title: 'Thời gian',
            dataIndex: 'createdAt',
            key: 'created_at',
            render: (value) => moment(value).format('DD/MM/YYYY HH:mm:ss')
        }
    ];
    const handleUpdate = async () => {
        setLoading(true);
        const response = await updateProfile(name,email);
        if (!response.success && response.errorCode === 401) {
            signOut();
            navigate(redirectAuth);
        }
        else if (!response.success){
            messageApi.open({
                type: 'error',
                content: response.message,
            });
        }
        else {
            messageApi.open({
                type: 'success',
                content: response.message,
            });
        }
        setLoading(false);
    }

    const handleUploadChange = (info) => {
        if (info.file.status) {
            getBase64(info.file.originFileObj, imageUrl => {
                setImageUrl(imageUrl);
            });
        }
    }

    const fetchDataLoginLogs = async (page = 1) => {
        setLoginLoading(true);
        try {
            const response = await getLoginLogs( {
                page: page,
                perPage: paginationLogin.pageSize
            });
            setDataLogin(response.data.data); // nested vì paginate
            setPaginationLogin({
                current: response.data.data.currentPage,
                pageSize: response.data.perPage,
                total: response.data.total
            });
        } catch (error) {
            console.error('Lỗi khi lấy dữ liệu log:', error);
        } finally {
            setLoginLoading(false);
        }
    };

    const fetchDataActivityLogs = async (page = 1) => {
        setActivityLoading(true);
        try {
            const response = await getActivityLogs( {
                page: page,
                perPage: paginationActivity.pageSize
            });
            setDataActivity(response.data.data); // nested vì paginate
            setPaginationActivity({
                current: response.data.data.currentPage,
                pageSize: response.data.perPage,
                total: response.data.total
            });
        } catch (error) {
            console.error('Lỗi khi lấy dữ liệu log:', error);
        } finally {
            setActivityLoading(false);
        }
    };

    // Update state when userData changes
    useEffect(() => {
        if (userData) {
            setName(userData.name || '');
            setEmail(userData.email || '');
        }
    }, [userData]);

    useEffect(() => {
        fetchDataLoginLogs().then(r => {});
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        fetchDataActivityLogs().then(r => {});
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // Show loading if still loading or no user data
    if (loading || !userData) {
        return (
            <Page title="Trang cá nhân">
                <div style={{ padding: '50px', textAlign: 'center' }}>
                    Loading...
                </div>
            </Page>
        );
    }

    return (
        <Page title="Trang cá nhân">
            {contextHolder}
            <Row gutter={[16,16]}>
                <Col xs={24} sm={24} md={24} lg={8} xl={8}>
                    <Card title={'Thông tin tài khoản'}>
                        <Flex justify={'center'} align={'center'}>
                            <Upload
                                name={'avatar'}
                                showUploadList={false}
                                onChange={handleUploadChange}
                                beforeUpload={(file) => false}
                            >
                                <Avatar
                                    style={{
                                        cursor: 'pointer'
                                    }}
                                    size={{
                                        xs: 120,
                                        sm: 120,
                                        md: 120,
                                        lg: 140,
                                        xl: 140,
                                        xxl: 160,
                                    }}
                                    icon={<AntDesignOutlined />}
                                />
                            </Upload>
                        </Flex>
                        <Info title={'Tên tài khoản'}>{userData.username}</Info>
                        <Info title={'Email'}>{userData.email}</Info>
                    </Card>
                </Col>
                <Col xs={24} sm={24} md={24} lg={16} xl={16}>
                    <Card title={'Cập nhật thông tin'}>
                        <Form layout="vertical">
                            <Row>
                                <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                    <Form.Item label={'Biệt danh'} name={'name'} initialValue={name}>
                                        <Input placeholder={userData.name} onChange={(e) => setName(e.target.value)}/>
                                    </Form.Item>
                                </Col>
                                <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                    <Form.Item label={'Email'} name={'email'} initialValue={email}>
                                        <Input placeholder={'Email'} onChange={(e) => setEmail(e.target.value)}/>
                                    </Form.Item>
                                </Col>
                                <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                    <Form.Item label={'UserAgent'}>
                                        <Input.TextArea disabled value={userData.userAgent}/>
                                    </Form.Item>
                                </Col>
                                <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                    <Flex justify={'end'}>
                                        <Button type={'primary'} onClick={handleUpdate}>Cập nhật</Button>
                                    </Flex>
                                </Col>
                            </Row>
                        </Form>
                    </Card>
                </Col>
                <Col xs={24} sm={24} md={24} lg={12} xl={12}>
                    <Card title={'Lịch sử đăng nhập'}>
                        <Table
                            rowKey="id"
                            columns={loginColumns}
                            dataSource={dataLogin}
                            loading={loginLoading}
                            scroll={{ x: 'max-content' }}
                            pagination={{
                                current: paginationLogin.current,
                                pageSize: paginationLogin.pageSize,
                                total: paginationLogin.total,
                                onChange: (page) => fetchDataLoginLogs(page)
                            }}
                        />
                    </Card>
                </Col>
                <Col xs={24} sm={24} md={24} lg={12} xl={12}>
                    <Card title={'Lịch sử thao tác'}>
                        <Table
                            rowKey="id"
                            columns={activityColumns}
                            dataSource={dataActivity}
                            loading={activityLoading}
                            scroll={{ x: 'max-content' }}
                            pagination={{
                                current: paginationActivity.current,
                                pageSize: paginationActivity.pageSize,
                                total: paginationActivity.total,
                                onChange: (page) => fetchDataActivityLogs(page)
                            }}
                        />
                    </Card>
                </Col>
            </Row>
        </Page>
    )
}

export default Profile;
